import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import {
  NavigationItem,
  navigationItemsInvoices,
} from '../../models/navigation-item-model';
import { LabelService } from '../../services/label.service';
import { classes, pages } from '../../shared/labels';
import { MatChipListboxChange, MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import {
  TableInvoiceFields,
  TableReceivedInvoiceFields,
} from '../../models/invoices';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { InvoicesService } from '../../services/invoices.service';
import { ErrorPanelService } from '../../services/error-panel.service';

@Component({
  selector: 'app-invoices-received',
  standalone: true,
  imports: [
    SharedModule,
    MatChipsModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
  ],
  templateUrl: './invoices-received.component.html',
  styleUrl: './invoices-received.component.scss',
})
export class InvoicesReceivedComponent implements OnInit {
  navigationItems: NavigationItem[];
  currentYear = new Date().getFullYear();

  invoices: TableReceivedInvoiceFields[] = [];
  isLoadingInvoices: boolean = true;

  displayedColumns: string[] = [
    'year',
    'status',
    'date',
    'type',
    'client',
    'total',
    'actions',
  ];

  constructor(
    public labelService: LabelService,
    private invoicesService: InvoicesService,
    private errorPanelService: ErrorPanelService
  ) {
    // highlight the correct page in the side bar
    this.navigationItems = navigationItemsInvoices.map((item) => {
      if (item.label === pages.invoices_received) {
        return { ...item, class: classes.hnb };
      }
      return { ...item };
    });
  }

  ngOnInit(): void {
    this.getInvoices();
  }

  getInvoices() {
    this.invoicesService.getReceivedInvoices().subscribe({
      next: (res) => {
        this.invoices = res;
        this.sortInvoices();
        this.isLoadingInvoices = false;
      },
      error: (err) => {
        console.error('Errore nel caricare le fatture ricevute', err);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel caricare le fatture ricevute. Ti chiediamo di rieffettuare il login.'
        );
        this.isLoadingInvoices = false;
      },
    });
  }
  sortInvoices() {
    this.invoices.sort((a, b) => {
      // Convert dd/mm/yyyy to Date objects for comparison
      const [dayA, monthA, yearA] = a.data.split('/').map(Number);
      const [dayB, monthB, yearB] = b.data.split('/').map(Number);
      const dateA = new Date(yearA, monthA - 1, dayA);
      const dateB = new Date(yearB, monthB - 1, dayB);

      // Compare dates first
      if (dateA.getTime() !== dateB.getTime()) {
        return dateB.getTime() - dateA.getTime(); // Most recent dates first
      }

      // If dates are equal, compare progressivo_numero
      return parseInt(b.progressivo_numero) - parseInt(a.progressivo_numero);
    });
  }

  onChipSelectionChange(event: MatChipListboxChange) {
    console.log(event);
  }

  onSort(event: any) {
    console.log(event);
  }

  showNotifications(invoice: TableInvoiceFields) {
    console.log(invoice);
  }

  previewInvoice(invoice: TableInvoiceFields) {
    console.log(invoice);
  }
}
